import { render, staticRenderFns } from "./ModelOverview.vue?vue&type=template&id=76370718&"
import script from "./ModelOverview.vue?vue&type=script&lang=ts&"
export * from "./ModelOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports